import ContainerWrapper from "@components/BasicComponents/Wrappers/ContainerWrapper/ContainerWrapper"
import ButtonComponent from "@components/Theme/Button/Button"
import Typography, {Size} from "@components/WebsiteRevamp/Typography/Typography"
import checkIfLinkIsCurrent from "@components/WebsiteRevamp/utils/checkIfLinkIsCurrent"
import ExternalIcon from "@components/icons/ExternalIcon"
import {MenuModuleType} from "@hooks/WorkWithJson/GetComponentDataByKey/GetComponentDataByKeyTypes"
import {useRouter} from "next/router"
import React from "react"

import styles from "./Subheader.module.scss"

type Props = {
	data: MenuModuleType[]
	title: string
}

const DefaultSubheader = (props: Props) => {
	const items = props.data

	const router = useRouter()

	return (
		<ContainerWrapper className={styles.subheaderBox}>
			<div className={`${styles.ItemBox} ${styles.ItemBoxDefault}`}>
				<Typography
					content={props.title}
					fontWeight={600}
					size={Size.M}
					style={{
						paddingLeft: "8px",
					}}
					// contrast
				/>
				<div className={`${styles.linksContainer}`}>
					{items.map((item) => {
						const {current, parent} = checkIfLinkIsCurrent(
							router.asPath,
							item.link,
							item.subLinksSelect,
						)
						const active = current || parent ? styles.active : ""
						const external = item.link?.includes("http")

						return (
							<React.Fragment key={`${item.id}`}>
								<ButtonComponent
									className={`${
										styles.defaultSubHeaderItem
									} ${
										external ? styles.external : ""
									} ${active} `}
									link={item?.link ?? ""}
									size={"small"}
									asLink
									buttonType={"text"}
								>
									<Typography
										content={item.menuTitle}
										size={Size.XXS}
										// contrast
										noPadding
									/>
									{external && (
										<ExternalIcon
											className={`${styles.svgIcon}  `}
										/>
									)}
								</ButtonComponent>
							</React.Fragment>
						)
					})}
				</div>
			</div>
		</ContainerWrapper>
	)
}

export default DefaultSubheader
